<template>
  <section>
    <h3 class="keyskills-title">Core Skills</h3>
    <div class="keyskills-row">
      <span class="skill">Engineering Management</span>
      <span class="skill">People Management</span>
      <span class="skill">Team Leadership</span>
      <span class="skill">Stakeholder Management</span>
      <span class="skill">Solution Architecture</span>
      <span class="skill">Project Management</span>
      <span class="skill">Delivery Management</span>
      <span class="skill">AI-Augmented Engineering</span>
      <span class="skill">CI/CD</span>
    </div>
    <div class="keyskills-row">
      <span class="technology">React</span>
      <span class="technology">TypeScript</span>
      <span class="technology">JavaScript</span>
      <span class="technology">AWS</span>
      <span class="technology">Node.js</span>
      <span class="technology">Angular</span>
      <span class="technology">Microservices</span>
      <span class="technology">BigQuery</span>
      <span class="technology">Git</span>
      <span class="technology">Azure</span>
    </div>
    <div class="keyskills-row">
      <span class="skill">Fintech</span>
      <span class="skill">Payments</span>
      <span class="skill">BNPL</span>
      <span class="skill">Lending</span>
      <span class="skill">Banking</span>
      <span class="skill">Insurance</span>
      <span class="skill">SaaS</span>
    </div>
  </section>
</template>

<script>
export default {
  name: "KeySkills"
};
</script>

<style lang="scss" scoped>
.keyskills-title {
  font-size: 1.55rem;
  color: #23415d;
  text-align: left;
  text-transform: uppercase;
  border-bottom: 1px solid #23415d;
}
.keyskills-row {
  padding: 10px;
  display: flex;
  flex-flow: row wrap;
  gap: 5px;

  span {
    height: 25px;
    font-size: 11px;
    font-weight: 900;
    padding-inline: 5px;
    border-radius: 3px;

    display: flex;
    place-content: center;
    place-items: center;
  }
}

.technology {
  background-color: #f6fbff;
  color: black;
}
.skill {
  background-color: #f6fbff;
  color: black;
}
</style>
